const faForms =
  document.querySelectorAll<HTMLIFrameElement>('.formAssemblyForm');

if (faForms.length > 0) {
  window.addEventListener('message', (evt) => {
    for (const faForm of faForms) {
      const origin = new URL(faForm.src).origin;
      const formId = faForm.dataset.formId;
      if (evt.origin === origin) {
        if (evt.data.heightChange && faForm.id === evt.data.iframeId) {
          const frameHeight = Math.ceil(evt.data.newHeight);
          faForm.style.height = frameHeight + 'px';
        }
        if (evt.data.contentLoaded && faForm.id === evt.data.iframeId) {
          faForm.style.display = '';
          let formData: Record<string, unknown> = {
            formReady: true,
          };

          if (Object.keys(faForm.dataset).length > 0) {
            formData = { ...formData, ...faForm.dataset };
          }

          formData = JSON.parse(JSON.stringify(formData));
          faForm.contentWindow?.postMessage(formData, '*');
        }
        if (evt.data.formTYPageLoaded && formId && formId === evt.data.formId) {
          const intro = document.querySelector<HTMLDivElement>('.xrx-fa-intro');
          if (intro) {
            intro.style.display = 'none';
          }
          const confirmation = document.querySelector<HTMLDivElement>(
            '.xrx-fa-confirmation'
          );
          if (confirmation) {
            faForm.style.display = 'none';
            confirmation.style.display = '';
          }
        }
      }
    }
  });
}
